import { ScrollArea } from '@/components/ui/scroll-area';
import { menuSections } from '@/config/navigation-config';
import { cn } from '@/lib/utils';
import { SidebarFooter } from './sidebar-footer';
import { SidebarHeader } from './sidebar-header';
import { SidebarMenuSection } from './sidebar-menu-section';
import { DesktopSidebarProps } from './types';

export function DesktopSidebar({
  isCollapsed,
  onToggleCollapse,
  currentPath,
  openSubMenus,
  onNavigate,
  onToggleSubMenu,
}: DesktopSidebarProps) {
  return (
    <div
      data-sidebar="desktop"
      className={cn(
        'hidden md:flex h-screen no-print bg-blue-900 text-white flex-col fixed',
        isCollapsed ? 'w-16' : 'w-64',
        'transition-all duration-300 z-50',
      )}
    >
      <SidebarHeader isCollapsed={isCollapsed} onToggleCollapse={onToggleCollapse} />
      <ScrollArea className="flex-1">
        <div className="py-2">
          {menuSections.map((section, sectionIndex) => (
            <SidebarMenuSection
              key={sectionIndex}
              section={section}
              currentPath={currentPath}
              isCollapsed={isCollapsed}
              openSubMenus={openSubMenus}
              onNavigate={onNavigate}
              onToggleSubMenu={onToggleSubMenu}
            />
          ))}
        </div>
        <SidebarFooter isCollapsed={isCollapsed} />
      </ScrollArea>
    </div>
  );
}
